import { Static, Type } from '@sinclair/typebox'
import { PROJECT_DISPLAY_NAME_MAX_LENGTH } from './project'

export const CreateOrRenameProjectRequest = Type.Object({
    displayName: Type.String({
        maxLength: PROJECT_DISPLAY_NAME_MAX_LENGTH,
    }),
})

export type CreateOrRenameProjectRequest = Static<typeof CreateOrRenameProjectRequest>

export const AddUserToProjectWithEmailRequest = Type.Object({
    userEmail: Type.String(),
    inviteProjectId: Type.String(),
})

export type AddUserToProjectWithEmailRequest = Static<typeof AddUserToProjectWithEmailRequest>
